<template>
  <div class="main">
    <div class="main-back">
      <div class="topcontent">
        <div class="main-img">
          <img src="@/assets/bwhyf_bocom/header-01.png" alt="" />
        </div>
      </div>

      <div class="condition-display">
        <div class="menu-replace" style="height: 0px">
          <!--当导航固定定位时顶替导航的空缺高度，避免页面跳动-->
        </div>
        <div class="detail-tab detailtab" id="nav-menu">
          <a class="detail-tab-item active2">产品详情</a>
          <a class="detail-tab-item">产品说明书</a>
        </div>
        <div class="section-content productDetail" id="tab1">
          <img
            class="productDetail-img1"
            src="@/assets/bwhyf_bocom/01.png"
            alt=""
          />
          <img
            class="productDetail-img2"
            src="@/assets/bwhyf_bocom/02.png"
            alt=""
          />
          <img
            class="productDetail-img4"
            src="@/assets/bwhyf_bocom/04.png"
            alt=""
          />
          <img
              class="productDetail-img5"
              src="@/assets/bwhyf_bocom/05.png"
              alt=""
          />
        </div>
        <div class="section-content" id="tab2">
          <img
              class="productDetail-img11"
              src="@/assets/bwhyf_bocom/11.png"
              alt=""
          />
          <div class="case">
            <ul>
              <li>
                <a
                  href="javascript:;"
                  @click="clickPdf('pdf/bwhyf/anleitung1.pdf')"
                >
                 招商信诺百万好运福意外伤害保险产品说明书
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="clickPdf('pdf/bwhyf/anleitung2.pdf')"
                >
                招商信诺附加百万好运福意外伤害医疗保险产品说明书
                </a>
              </li>

            </ul>
          </div>
        </div>
        <div class="reminder">
          *页面内容仅供参考，不构成保险合同组成部分，保险责任、责任免除、等待期、理赔要求等重点内容，以保险合同为准。<br/>
          *保险产品：招商信诺百万好运福意外伤害保险产品计划<br/>
          *承保公司：招商信诺人寿保险有限公司<br/>
          *代理机构：交通银行股份有限公司太平洋信用卡中心<br/>
          *保险产品适用条款：<a href="javascript:;" @click="clickPdf('pdf/bwhyf/clause1.pdf')">《招商信诺百万好运福意外伤害保险条款》</a>、<a href="javascript:;" @click="clickPdf('pdf/bwhyf/clause2.pdf')">《招商信诺附加百万好运福意外伤害医疗保险条款》</a><br/>
          *条款编码：招商信诺【2023】意外伤害保险020号、招商信诺【2023】医疗保险022号<br/>
          *消费者投诉维权途径：保险公司客服电话 95362<br/>
          卡中心客服电话：4008009888
        </div>
        <div class="yy" @click="clickYy">
          <div class="btn">预约顾问</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/utils/navScroll";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import request from "@/utils/request";

export default {
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Autoplay, Pagination],
      userInfo:[],
      pdInfo:{'hq':{'pd':'bwhyfhq','pdId':'C_BXCWDFK'},'wh':{pd:'bwhyfwh','pdId':'C_WXCWDFK'}},
      pdName:'wh' //手动调整,hq | wh
    };
  },
  mounted() {
    let navHeight =
      document.getElementsByClassName("menu-replace")[0].offsetParent.offsetTop;
    // console.log(document.getElementsByClassName("menu-replace")[0].getBoundingClientRect())
    let navFix = document.getElementById("nav-menu");
    let menuH = navFix.offsetHeight;
    //console.log(navHeight, menuH);
    /**
     * 监听滚动条
     */
    this.ismenutop(navHeight, navFix, menuH);
    window.removeEventListener("scroll", () => {
      this.ismenutop(navHeight, navFix, menuH);
    });
    window.addEventListener("scroll", () => {
      this.ismenutop(navHeight, navFix, menuH);
    });
    /*导航定位*/
    new hScroll({
      nav1: ".detailtab a", //导航对应的元素
      nav2: ".section-content", //监听的元素
      nav3: menuH, //导航栏高度
      checkClass: "active2", //选中的样式
    });
    this._ini();
  },
  methods: {
    // 判断导航栏是否置顶
    ismenutop(navHeight, navFix, menuH) {
      let scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      let menuReplace = document.getElementsByClassName("menu-replace")[0];
      if (menuReplace) {
        if (scrollTop > navHeight) {
          navFix.classList.add("nav-fixed");
          menuReplace.style.height = menuH + "px";
        } else {
          navFix.classList.remove("nav-fixed");
          menuReplace.style.height = 0;
        }
      }
    },
    _ini(){
      let _this = this;

      let data = {pd:_this.pdInfo[_this.pdName]['pd']}
      request.post(
        '/projects/api/index.php/bocom/userView',
        data
      ).then(res => {
        _this.userInfo = res.data;
        console.log(res);
      }).catch(err=>{
        console.log(err)
      });
      //console.log(_this.userInfo);
    },
    clickYy(){
      let _this = this;
      if(_this.userInfo.id){
        request.post(
          '/projects/api/index.php/bocom/userClick',
          {pd:_this.pdInfo[_this.pdName]['pd'],id:_this.userInfo.id}
        ).then(res => {
          console.log(res);
        }).catch(err=>{
          console.log(err)
        });
      }

      var bankUrlHost = 'https://creditcardapp.bankcomm.com';
      if (window.location.origin.indexOf('test') !== -1) {
        bankUrlHost = 'https://paymenttest.bankcomm.com';
      }

      //延迟1秒请求
      setTimeout(function () {
        //console.log(prodId);
        let pdId = _this.pdInfo[_this.pdName]['pdId'];
        window.location =
          bankUrlHost +
          '/cbwsInemPubWeb/thirdpay/appointment.html?prodId=' +
          pdId;
      }, 1000);
    },
    clickPdf(pdf){
        var pdfPath = window.location.origin+'/campaign/bocomcc/'+this.pdInfo[this.pdName]['pd']+'/'+pdf;
        if (pdfPath) {
          window.open(
            '/campaign/bocomcc/auto-js/pdf/web/viewer.html?file=' + pdfPath,
            '_self'
          );
        }
    }
  },
};
</script>

<style scoped>
.main {
  width: 3.75rem;
  margin: 0 auto;
}

.main-back {
  width: 100%;
  background-color: #f4f6f9;
  padding-bottom: 0.71rem;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.16rem 0;
}

.header img {
  width: 0.2rem;
  height: 0.2rem;
  margin-left: 0.16rem;
}

.header-title {
  font-size: 0.17rem;
  font-weight: bold;
}

.main-img,
.marshalling {
  width: 100%;
}

.main-img img {
  width: 3.75rem;
  height: 1.8rem;
  display: block;
}

.condition-display {
  position: relative;
}

.menu-replace {
  position: relative;
  width: 100%;
  height: 0;
}

.detail-tab {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  border-bottom: solid 1px #f0f0f0;
}

.nav-fixed {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  _position: absolute;
  _bottom: auto;
  _top: expression(eval(document.documentElement.scrollTop));
}

.navtab {
  position: fixed !important;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
}

.detail-tab-item {
  font-size: 0.14rem;
  color: #9da5b1;
  padding: 0.155rem 0 0.11rem;
  font-weight: bold;
}

.active2 {
  color: #000000;
  position: relative;
  font-weight: bold;
}

.active2::after {
  content: "";
  width: 0.17rem;
  height: 0.02rem;
  background-color: #000000;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.productDetail {
  background-color: #ffffff;
}

.productDetail img {
  display: block;
  /* width: 3.4rem; */
}

.productDetail .productDetail-img1 {
  width: 3.75rem;
  height: 7.295rem;
  margin: 0 auto;
}

.productDetail-img2 {
  width: 3.75rem;
  height: 3.32rem;
  margin: 0 auto;
}

.productDetail-img3 {
  width: 3.75rem;
  height: 3.05rem;
  margin: 0 auto;
}
.productDetail-img4 {
  width: 3.75rem;
  height: 6.13rem;
  margin: 0 auto;
}
.productDetail-img5 {
  width: 3.75rem;
  height: 6.75rem;
  margin: 0 auto;
}

.productDetail-img11 {
  width: 3.75rem;
  margin: 0 auto;
}
.case {
  padding: 0.125rem 0.1rem 0;
}

.case ul {
  padding: 0;
  margin: 0;
}

.case ul li {
  background-color: #fff;
  padding: 0.1rem 0.42rem 0.1rem 0.505rem;
  position: relative;
  margin-bottom: 0.1rem;
  border-radius: 7px;
}

.case ul li a {
  display: block;
  color: #333;
  font-size: 0.13rem;
}

.case ul li::before {
  position: absolute;
  content: "";
  background: url("../../assets/public/pdf.png") no-repeat center center;
  background-size: 0.28rem 0.29rem;
  width: 0.28rem;
  height: 0.29rem;
  left: 0.115rem;
  top: 50%;
  margin-top: -0.145rem;
}

.case ul li::after {
  position: absolute;
  content: "";
  background: url(../../assets/public/icon-07.png) no-repeat center center;
  background-size: contain;
  width: 0.17rem;
  height: 0.17rem;
  right: 0.195rem;
  top: 50%;
  margin-top: -0.085rem;
}

.reminder p {
  color: #999;
  font-size: 0.1rem;
  margin-bottom: 0.09rem;
}
.reminder {
  padding: 0.05rem 0.1rem 0;
  color: #999;
  font-size: 0.1rem;
  line-height: 0.14rem;
}
.reminder>a{
  color: #fc9b20;
  font-size: 0.1rem;
  line-height: 0.14rem;
}
.mySwiper {
  height: 1.5rem;
}
:deep(.swiper-pagination) {
  width: 0.46rem;
  display: flex;
  justify-content: center;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.05rem;
  margin: 0 auto;
  border-radius: 0.025rem;
  background-color: #f8f0ff;
}
:deep(.swiper-pagination-bullet) {
  margin: 0 !important;
  background-color: transparent !important;
  flex: 1;
  height: 0.05rem;
  border-radius: 0.025rem;
  opacity: 1;
}
:deep(.swiper-pagination-bullet-active) {
  background-color: #7d50ff !important;
}
</style>
